var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.state.diasASolicitar > 1)?_c('label',{staticClass:"dias-a-solicitar",class:_vm.primaryTextClass},[(_vm.state.config.showDetails === true)?[_vm._v(_vm._s(_vm.$t('message.licenseComponent.licenseBox.discountPlural', {
        saldo: _vm.state.diasASolicitar,
        tipo: _vm.licenseName.toLowerCase()
      })))]:[_vm._v(_vm._s(_vm.$t('message.licenseComponent.licenseBox.registerPlural', {
        saldo: _vm.state.diasASolicitar,
        tipo: _vm.licenseName.toLowerCase()
      })))]],2):(_vm.state.diasASolicitar === 1 && _vm.state.request.medioDia === true)?_c('label',{staticClass:"dias-a-solicitar",class:_vm.primaryTextClass},[(_vm.state.request.hoursRange > 1)?[_vm._v(_vm._s(_vm.$t('message.licenseComponent.licenseBox.discountHalf', {
        hoursRanges: _vm.state.request.hoursRange,
        tipo: _vm.licenseName.toLowerCase()
      })))]:(_vm.state.request.hoursRange >= 0.5 && _vm.state.request.hoursRange <= 1)?[_vm._v(_vm._s(_vm.$t('message.licenseComponent.licenseBox.discountHalf', {
        hoursRange: _vm.state.request.hoursRange,
        tipo: _vm.licenseName.toLowerCase()
      })))]:(_vm.state.config.showDetails && _vm.state.request.hoursRange === '')?[_vm._v(_vm._s(_vm.$t('message.licenseComponent.licenseBox.discountHalf', {
        tipo: _vm.licenseName.toLowerCase()
      })))]:[_vm._v(_vm._s(_vm.$t('message.licenseComponent.licenseBox.registerHalf', {
        tipo: _vm.licenseName.toLowerCase()
      })))]],2):_c('label',{staticClass:"dias-a-solicitar",class:_vm.primaryTextClass},[(_vm.state.config.showDetails === true)?[_vm._v(_vm._s(_vm.$t('message.licenseComponent.licenseBox.discountSingular', {
        saldo: _vm.state.diasASolicitar,
        tipo: _vm.licenseName.toLowerCase()
      })))]:[_vm._v(_vm._s(_vm.$t('message.licenseComponent.licenseBox.registerSingular', {
        saldo: _vm.state.diasASolicitar,
        tipo: _vm.licenseName.toLowerCase()
      })))]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }